import {Modal} from '../../UI/Modal';
import {Button} from '../../UI/Button';
import {TextButton} from '../../UI/Button/Text';
import {Input} from '../../UI/Input';

import {useAppDispatch, useAppSelector} from '../../../store/app-hooks';
import {useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {initial, IWasteCategoryItemForm, validationSchema} from './formModel';
import {FIELD_LABELS} from '../../../constants';
import {ErrorMessage} from '../../UI/ErrorMessage';
import {ModalActions, ModalBody} from '../../UI/Modal/ModalBuildingBlocks';
import {
    CreateWasteCategoryItem,
    newWasteCategoryItem,
    wasteCategoriesError,
    wasteCategoriesIsSubmitting,
} from '../../../store/wasteCategory/wasteCategorySlice';

type WasteCategoryItemModalProps = {
    wasteCategoryId: string;
    closeModal: VoidFunction;
};

const WasteCategoryItemModal = ({wasteCategoryId, closeModal}: WasteCategoryItemModalProps) => {
    const dispatch = useAppDispatch();
    const formError = useAppSelector(wasteCategoriesError);

    const {ADD_TO_LIST_LABEL, CANCEL_LABEL} = FIELD_LABELS;

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm<IWasteCategoryItemForm>({
        resolver: yupResolver(validationSchema),
        defaultValues: initial,
    });

    const isSubmitting = useAppSelector(wasteCategoriesIsSubmitting);

    const onActionClick = (formValues: IWasteCategoryItemForm) => {
        const {name} = formValues;

        const payLoad: CreateWasteCategoryItem = {
            data: {name},
            wasteCategoryId,
        };

        dispatch(newWasteCategoryItem(payLoad))
            .unwrap()
            .then(() => closeModal())
            .catch(({message}) => console.log(message));
    };

    return (
        <Modal title={'New Category Item'}>
            <ModalBody>
                <Input
                    label="Name"
                    placeholder="Type here"
                    required
                    error={!!errors.name}
                    errorMessage={errors.name?.message}
                    {...register('name')}
                />

                {formError && <ErrorMessage message={formError} />}
            </ModalBody>
            <ModalActions>
                <Button
                    type="submit"
                    onClick={handleSubmit(onActionClick)}
                    disabled={isSubmitting}
                    label={ADD_TO_LIST_LABEL}
                />
                <TextButton variant="Danger" label={CANCEL_LABEL} onClick={closeModal} />
            </ModalActions>
        </Modal>
    );
};

export default WasteCategoryItemModal;
